import * as React from "react";
import image from "../assets/logo.png";
import imagearshe from "../assets/logonew.png";

import { StyleSheet } from 'react-native';
import { fontSize } from "@mui/system";
import { useTranslation } from 'react-i18next';
import i18n from '../assets/lang/i18next';


const styles = StyleSheet.create({
    flash: {
        width: '100%', backgroundColor: '#000'
    },
    testClass: {
        backgroundColor: 'red'
    }
})
export class ComponentToPrintCondonser extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = { checked: false };
    }

    canvasEl;

    componentDidMount() {
        const ctx = this.canvasEl.getContext("2d");
        if (ctx) {
            ctx.beginPath();
            ctx.arc(95, 50, 40, 0, 2 * Math.PI);
            ctx.stroke();
            ctx.fillStyle = "rgb(200, 0, 0)";
            ctx.fillRect(85, 40, 20, 20);
            ctx.save();
        }
    }

    handleCheckboxOnChange = () =>
        this.setState({ checked: !this.state.checked });

    setRef = (ref) => (this.canvasEl = ref);

    render() {
        const { text } = this.props;
        return (


            <div style={{ backgroundColor: 'white', width: '100%', fontFamily: 'IranSans' }}>
                <style type="text/css" media="print">
                    {"\   @page  {  size: A4 portrait; margin:15mm }\
"}
                </style>
                <div />

                <div style={{ backgroundColor: '#022a4c',  border: 'none', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 10,height:50,  flexWrap: 'wrap' }}>
                    <img alt="arshehar" src={image} width="50" height="50" />

                    <div align="center" style={{marginRight:-80}}>
                        <h2 style={{ color: 'white', fontSize: 16, margin: 0,padding:0 }}>شرکت آرشه کار</h2>
                        <p style={{ color: 'white', fontSize: 13,margin:0,padding:0 }}>تولید و تجهیز سیستم های برودتی</p>
                    </div>
                    <img alt="arshehar" src={imagearshe} height="35" width="150" style={{paddingTop:7}}/>

                </div>
                <div align="center">

                    <img alt="arshehar" src={this.props.person.axevaprator} height="210" />
                </div>

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none' }}>
                        <thead style={{ backgroundColor: '#a5a5a5' }}>
                            <tr style={{ backgroundColor: '#a5a5a5' }}>
                                <td><h4 style={{ fontSize: 14, margin: 0, padding: 5 }}>{i18n.t('fanspecifications')}</h4></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody style={{ border: 'none' }}>

                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('speed')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.sorat}  {i18n.t('RPM')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>IP</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.ip}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Voltage')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.voltajfan}  {i18n.t('V')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Frequency')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.ferekans}  {i18n.t('Hz')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Current')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.jaryanfan}  {i18n.t('A')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Power')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.tavanfan}  {i18n.t('KW')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}> </p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}> </p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}> </p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}> </p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}></p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}> </p></td>
                            </tr>

                        </tbody>
                    </table>
                    <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none' }}>
                        <thead style={{ backgroundColor: '#a5a5a5' }}>
                            <tr style={{ backgroundColor: '#a5a5a5' }}>
                                <td><h4 style={{ fontSize: 14, margin: 0, padding: 5 }}>{i18n.t('Specifications')}</h4></td>
                                <td></td>
                            </tr>
                        </thead>

                        <tbody style={{ border: 'none' }} >
                            <tr style={{ display: 'none' }}>
                                <td>Canvass</td>
                                <td>
                                    <canvas height="100" ref={this.setRef} width="200">
                                    </canvas>
                                </td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Condenser')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.selectedmodeltitle}</p> </td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Nominalcapacity')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}> KW</p> </td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('surfaceareaofheattransfer')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.sathtabadolhararat}  {i18n.t('M2')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Circuitvol')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.gazgiri}  {i18n.t('litre')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Nooffans')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.tedadfan}  {i18n.t('PCS')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('FanDiameter')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.ghotrefan}  {i18n.t('cm')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Airflow')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.debi}  {i18n.t('m3hr')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Finspace')}</p> </td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.faselefin}  {i18n.t('mm')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Inlet')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.vorodi}  {i18n.t('inch')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Outlet')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.khoroji}  {i18n.t('inch')}</p></td>
                            </tr>
                            <tr >
                                <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('Weight')}</p></td>
                                <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.vazn}  {i18n.t('kg')}</p></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table style={{ backgroundColor: 'white', width: '100%', direction: 'rtl', border: 'none' }}>
                    <thead style={{ backgroundColor: '#a5a5a5' }}>
                        <tr style={{ backgroundColor: '#a5a5a5' }}>
                            <td><h4 style={{ fontSize: 14, margin: 0, padding: 5 }}>{i18n.t('Connections')}</h4></td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr >
                            <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('InletReciver')}</p></td>
                            <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.vorodireciver}  {i18n.t('inch')}</p></td>
                        </tr>
                        <tr >
                            <td><p style={{ fontSize: 12, padding: 5, margin: 0 }}>{i18n.t('OutletReciver')}</p></td>
                            <td><p style={{ fontSize: 12, direction: 'ltr', textAlign: 'right', margin: 0, padding: 0 }}>{this.props.person.khorojireciver}  {i18n.t('inch')}</p></td>
                        </tr>

                    </tbody>
                </table>
                <hr></hr>

                <div style={{ direction: 'rtl', textAlign: 'right', fontSize: 11 }}>
                    <p style={{ margin: 0 }}>ابعاد براساس میلی متر می باشد.</p>
                    <p style={{ margin: 0 }}>ظرفیت نامی در شرایط دلتا تی 15 درجه سانتیگراد محاسبه شده است.</p>
                    <hr></hr>
                    <ul>
                        <li>اطلاعات فوق وزن و ابعاد خالص کندانسور می باشد و بدون در نظر گرفتن بسته بندی محاسبه گردیده است.</li>
                        <li>تمامی محصولات آرشه کار دارای مجوز CE از اروپا می باشد.</li>
                        <li>تمامی محصولات به مدت یکسال در مقابل عیوب ناشی از ساخت گارانتی می باشد.</li>
                        <li>محصولات آرشه دارای 10 سال خدمات پس از فروش می باشد.</li>
                        <li>درصورت درخواست مشتری قابلیت ارایه شاسی جدا از کندانسور نیز می باشد.</li>
                        <li>درصورت درخواست مشتری کندانسور با شاسی و بدنه استیل نیز قابل تولید می باشد.</li>
                        <li>براساس درخواست مشتری قابلیت نصب فن با صدای پایین نیز می باشد.</li>
                    </ul>
                </div>

                <div style={{ backgroundColor: 'red', width: '100%', height: 35, direction: 'ltr', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <h3 style={{ color: 'white', marginLeft: 10, fontSize: 13 }}><a href="https://app.arshehkar.com">app.arshehkar.com</a></h3>
                    <h3 style={{ color: 'white', marginRight: 20, fontSize: 13 }}>info@arshehkar.com</h3>
                </div>

            </div>
        );
    }
}

export const FunctionalComponentToPrintCondonser = React.forwardRef((props, ref) => {
    // eslint-disable-line max-len
    return <ComponentToPrintCondonser ref={ref} text={props.text} />;
});
